import xss, { FilterXSS } from 'xss'
import { URL } from './regex'

function sanitizeHTML(html: string): string {
	const onTagAttr = (tag: string, name: string, value: string) => {
		if (tag === 'a' && name === 'href' && URL.test(value)) {
			return `href="${value}" rel="noopener noreferrer" target="_blank" data-testid="external-link"`
		}
	}
	const xssFilterOptions = {
		onTagAttr,
		whiteList: {
			a: [],
		},
		stripIgnoreTag: true,
		stripIgnoreTagBody: ['script'],
	}
	const myXSS = new FilterXSS(xssFilterOptions)
	return myXSS.process(html)
}
function parse(markdown: string): string {
	return sanitizeHTML(markdown)
}

const methods = {
	parse,
}

export default methods
